<template>
  <div class="select-student-form">
    <HMModalHeader :title="$t(title)" @close="$emit('close')" />
    <div class="container">
      <div class="row">
        <div class="col-12 mt-3">
          <HMSearch v-model="search" />
        </div>
        <div class="col-12">
          <HMPaginatedTable
            name="select-student-table"
            api="sale/getSalesCustomers"
            :fields="this.tableFields"
            :query="query"
            class="mt-3"
          >
            <template slot="full_name" slot-scope="{ data }">
              {{ data.full_name }}
            </template>
            <template slot="status" slot-scope="{ data }">
              <Status :isActive="data.status" />
            </template>
            <template slot="select" slot-scope="{ data }">
              <div class="select-icon p-2" @click="selectStudent(data)">
                <i class="fal fa-plus"></i>
              </div>
            </template>
          </HMPaginatedTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Status from '@/web/components/customers/Status.vue';

export default {
  name: 'HMSelectStudentModal',
  components: {
    Status,
  },
  props: {
    title: {
      type: String,
      default: 'GENERAL.TITLE.SELECT_STUDENT',
    },
    studentSelected: { type: Function },
  },
  computed: {
    query() {
      return {
        q: this.search,
      };
    },
  },
  data() {
    return {
      processing: false,
      search: '',
      tableFields: [
        {
          name: 'full_name',
          title: this.$t('ORDERS.TABLE.NAME'),
          cssClass: 'h5',
        },
        {
          key: 'email',
          title: this.$t('GENERAL.LABEL.EMAIL'),
        },
        {
          name: 'status',
          title: this.$t('CUSTOMERS.TABLE.STATUS'),
        },
        {
          name: 'select',
          shrink: true,
          cssClass: 'p-0',
        },
      ],
    };
  },
  methods: {
    async selectStudent(student) {
      if (this.processing) return;
      this.processing = true;
      await this.studentSelected(student);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
.select-student-form {
  .vm--modal {
    max-width: 800px;
  }
}
.select-icon {
  cursor: pointer;
  &:hover {
    color: $coral;
  }
}
</style>
